import { SafeAreaView } from "react-native-safe-area-context";
import { SkeletonText } from "../../../common/skeletons/skeleton-loader";
import { ScrollView, View } from "react-native";
import { memo } from "react";
import SettingsCard from "./settings-card";
import Separator from "../../../common/separator";

const SettingsSkeleton = () => {
  return (
    <SafeAreaView className="flex-1 bg-gray-50 pt-0 gap-8">
      <ScrollView className="flex-1" contentContainerStyle={{ paddingTop: 53 }}>
        <View className="flex-1 w-full max-w-2xl mx-auto p-1 sm:p-6 pb-40 sm:pb-20">
          <View className="pt-0 gap-8">
            <SettingsCard noSpacing>
              <View className="space-y-4">
                <SkeletonText lines={1} className="w-3/4" />
                <SkeletonText lines={2} className="w-1/2" />
                <View className="h-14 bg-gray-100 rounded-md" />
              </View>
              <Separator size="sm" />
              <View className="space-y-4">
                <SkeletonText lines={1} className="w-3/4" />
                <SkeletonText lines={2} className="w-1/2" />
                <View className="h-10 w-14 bg-gray-100 rounded-md" />
              </View>
            </SettingsCard>
            <SettingsCard noSpacing>
              <View className="space-y-4">
                <SkeletonText lines={1} className="w-3/4" />
                <SkeletonText lines={2} className="w-1/2" />
                <View className="h-48 bg-gray-100 rounded-md" />
              </View>
            </SettingsCard>
            <SettingsCard noSpacing>
              <View className="space-y-4">
                <SkeletonText lines={1} className="w-3/4" />
                <SkeletonText lines={2} className="w-1/2" />
                <View className="h-32 bg-gray-100 rounded-md" />
              </View>
            </SettingsCard>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default memo(SettingsSkeleton);
